import { MouseEvent } from "react";
import { useCurrentUser } from "hooks/useCurrentUser";
import { trpc } from "lib/trpc";
import { ClientUser } from "@compass/shared/types";

export const useFollow = (id: number) => {
    const currentUser = useCurrentUser();
    const queryClient = trpc.useContext();
    const showFollowButton = currentUser?.id !== id;

    const followMutation = trpc.users.toggleFollow.useMutation({
        onSuccess: () => {
            queryClient.users.getPublic.invalidate({ id });
            queryClient.users.me.invalidate();
        },
        onError: (e) => {
            console.error(e);
        },
    });

    const isFollowed = Boolean(
        currentUser?.follows?.find((follow: ClientUser) => follow.id === id),
    );

    const handleFollow = (event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        if (currentUser?.id && id) {
            followMutation.mutate({ userId: id });
        }
    };

    return {
        handleFollow,
        isFollowed,
        showFollowButton,
        followLoading: followMutation.isPending,
    };
};
